export const formatSubmitValues = (formValues, includeSendValue = false) => {
  const values = {};

  Object.keys(formValues).map((key) => {
    if (formValues[key].hidden && !formValues[key].sendHidden) {
      return true;
    }

    let { value } = formValues[key] ?? {};

    if (includeSendValue && typeof formValues[key].sendValue !== 'undefined') {
      value = formValues[key].sendValue;
    }

    if (
      !Number.isNaN(Date.parse(formValues[key].value)) &&
      typeof formValues[key].value === 'string' &&
      formValues[key].value.includes('/')
    ) {
      const parts = formValues[key].value.split('/');
      Object.assign(values, {
        [key]: `${parts[2]}-${parts[0]}-${parts[1]}`
      });
    } else {
      Object.assign(values, {
        [key]: value
      });
    }
    return true;
  });
  return values;
};
